//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../library/umum.js'


export default {
  data() {
    return {

      form : {
        nama : '',
        des_kel : '',
        no : '',
        file : null,
        createdAt : '',
        editedAt : '',
        status : 0,
        keterangan : 'Masih dalam proses pemeriksaan',

        fileOld : '',


        KODE_KECAMATAN: '',
        KODE_DESA : '',
        KODE_ALAMAT : '',
        KODE_NTTD : '',
        KODE_NOMOR : '',
        KODE_TTD : '',
        KODE_TANGGAL : '',

      },

      uraian : {
        agama_uraian : '',
      },


      
      fileOld: '',
      list_data : [],

      page_limit : 8,
      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_reject: false,
      mdl_approve : false,
      modal_lihat : false,
      modal_lampiran : false,


      btn_add: false,

      UMUM : UMUM,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_srv_suketLainnya + "viewMaster", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    approveData : function(number) {

      // console.log(this.form.no)

      if (this.form.no == '' || this.form.no == ' '|| this.form.no == null || this.form.no == undefined) {

        alert("Mohon Isi Nomor Surat Terlebih dahulu")
      } else {

        this.form.KODE_NOMOR  = this.form.no

        this.form.editedAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_suketLainnya + "verifikasi", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

      }


    },


    rejectData : function(){
      if (this.form.keterangan == '' || this.form.keterangan == ' '|| this.form.keterangan == null || this.form.keterangan == undefined) {
        alert("Mohon Isi Keterangan Pengembalian Terlebih dahulu")
      } else {
        this.form.editedAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_suketLainnya + "verifikasi", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              no : this.form.no,
              status : 2,
              keterangan : this.form.keterangan,
              fileOld : this.fileOld,
              editedAt :  UMUM.NOW(),
              agenda : false,
            })
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

      }
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_srv_suketLainnya + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },

    selectData : function(data){
        this.form.id = data.data.id;
        this.form.nama= data.data.nama;
        this.form.createdAt= data.data.createdAt;
        this.form.editedAt = data.data.editedAt;
        this.form.status= data.data.status;
        this.form.no= data.data.no;
        this.form.keterangan= data.data.keterangan;
        this.form.fileOld = data.data.file;



        this.fileOld = data.data.file;


        this.$store.state.DES_KEL = data.desa.uraian
        this.$store.state.KECAMATAN = data.kecamatan.uraian


        this.form.KODE_KECAMATAN = data.kecamatan.uraian
        this.form.KODE_DESA  = data.desa.uraian
        this.form.KODE_ALAMAT  = data.desa.alamat
        this.form.KODE_NTTD  = data.pegawai.nama
        this.form.KODE_TTD  = this.$store.state.url.URL_APP+'uploads/'+this.fileOld

        console.log(this.form.KODE_TTD);
        console.log(data)
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


        extDocxPDf : function(data){
          const text =  data.split('.')

          return text[0]+'_generate.pdf'
        }





    // ====================================== PAGINATE ====================================







  },

  mounted () {

    var profilex = JSON.parse(localStorage.profile)
    var profile = profilex.profile
    this.$store.state.ID_DES_KEL = profile.des_kel
    this.form.des_kel = profile.des_kel

    const date = new Date();

    const tgl  = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()

    this.form.KODE_TANGGAL = UMUM.tglConvertX(tgl)

    // console.log(this.form.KODE_TANGGAL);
    



    this.getView();
  },
}
